import { Col, Grid, Row } from 'react-bootstrap'
import { ERROR_MESSAGE_TYPE, INFO_MESSAGE_TYPE } from '../../constants/UserMessages'
import {
  getFirContentByModelId,
  getFitContentByModelId,
  getPDB,
  getSaxsSubtractionAsListBySubtractionId,
  getSubtractionsAsListByDataCollectionIds,
} from '../../api/ispyb'

import Loading from '../../components/Loading'
import React from 'react'
import SaxsAbInitioPDBViewer from '../../components/saxs/abInitioAnalysis/SaxsAbInitioPDBViewer'
import SaxsAbInitioTable from '../../components/saxs/abInitioAnalysis/SaxsAbInitioTable'
import SaxsAbInitioUpperPanel from '../../components/saxs/abInitioAnalysis/SaxsAbInitioUpperPanel'
import SaxsRequester from './helpers/SaxsRequester'
import UserMessage from '../../components/saxs/UserMessage'
import { axios } from 'config/axios'
import { connect } from 'react-redux'
import { parseDataCollections } from '../../helpers/Saxs/SaxsDataCollectionMapper'
import { parseSubtractions2 } from '../../helpers/Saxs/SaxsSubtractionsMapper'
import qs from 'qs'

class SaxsAbInitioContainer extends React.Component {
  render() {
    if (this.props.user.username === null || this.props.user.token === null) {
      return null
    }

    return (
      <div style={{ paddingBottom: '70px' }}>
        <SaxsRequester
          url={getSubtractionsAsListByDataCollectionIds(
            this.props.user,
            this.props.proposal,
            this.props.dataCollectionId
          )}
          parser={parseDataCollections}
        >
          {dataCollections =>
            !dataCollections ? null : (
              <SaxsRequester
                url={getSaxsSubtractionAsListBySubtractionId(
                  this.props.user,
                  this.props.proposal,
                  dataCollections[0].subtractionId
                )}
                parser={parseSubtractions2}
              >
                {subtractions =>
                  !subtractions ? null : (
                    <div>
                      <SaxsRequester
                        url={getFirContentByModelId(
                          this.props.user,
                          this.props.proposal,
                          subtractions[0].subtractionId,
                          subtractions[0].abInitioModels[0].shapeDeterminationModel.modelId
                        )}
                        parser={data => data}
                      >
                        {firData => (
                          <SaxsRequester
                            url={getFitContentByModelId(
                              this.props.user,
                              this.props.proposal,
                              subtractions[0].subtractionId,
                              subtractions[0].abInitioModels[0].shapeDeterminationModel.modelId
                            )}
                            parser={data => data}
                          >
                            {fitData => (
                              <SaxsAbInitioUpperPanel
                                firContent={firData}
                                fitContent={fitData}
                                subtraction={subtractions[0]}
                                user={this.props.user}
                              />
                            )}
                          </SaxsRequester>
                        )}
                      </SaxsRequester>

                      <Grid fluid>
                        <Row>
                          <Col xs={12} md={12} lg={3}>
                            <SaxsPDBContainer
                              user={this.props.user}
                              proposal={this.props.proposal}
                              subtraction={subtractions[0]}
                            />
                          </Col>
                          <Col xs={12} md={12} lg={9}>
                            <SaxsAbInitioTable
                              subtractions={subtractions}
                              proposal={this.props.proposal}
                              user={this.props.user}
                            />
                          </Col>
                        </Row>
                      </Grid>
                    </div>
                  )
                }
              </SaxsRequester>
            )
          }
        </SaxsRequester>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps, () => null)(SaxsAbInitioContainer)

class SaxsPDBContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fetching: true,
      fetched: false,
      XYZ: null,
      subtraction: null,
    }

    this.getModels = this.getModels.bind(this)
    this.getDamaverModel = this.getDamaverModel.bind(this)
    this.getDamfiltModel = this.getDamfiltModel.bind(this)
    this.getDammin = this.getDammin.bind(this)
  }

  render() {
    // handles the loader
    if (this.state.fetching === true) {
      return <Loading />
    }

    // handles http request failure
    if (this.state.fetched === false && this.state.fetching === false) {
      return (
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <UserMessage type={ERROR_MESSAGE_TYPE} message="Retrieval of the data failed." />
            </Col>
          </Row>
        </Grid>
      )
    }

    if (this.state.fetched === true) {
      if (this.state.message) {
        return <UserMessage type={INFO_MESSAGE_TYPE} message={this.state.message} />
      }
      return <SaxsAbInitioPDBViewer data={this.state.XYZ} />
    }
  }

  componentDidMount() {
    axios({
      method: 'POST',
      url: getPDB(this.props.user, this.props.proposal),
      data: qs.stringify({ models: JSON.stringify(this.getModels()) }),
    })
      .then(response => {
        if (response.data) {
          let XYZ = ''
          if (response.data.models !== null) {
            for (let i = 0; i < response.data.models.length; i++) {
              XYZ = XYZ + response.data.models[i].XYZ
            }
            this.setState({ fetching: false, fetched: true, subtraction: this.props.subtraction, XYZ: XYZ })
          } else {
            this.setState({
              fetching: false,
              fetched: true,
              subtraction: this.props.subtraction,
              message: 'There is no 3D model to view.',
            })
          }
        }
      })
      .catch(() => {
        this.setState({
          fetching: false,
          fetched: false,
          subtraction: this.props.subtraction,
        })
      })
  }

  getModels() {
    /** If no models we merge all **/
    const modelsMerged = []

    const damaverModel = this.getDamaverModel()
    if (damaverModel !== undefined) {
      damaverModel.opacity = 0.2
      modelsMerged.push(damaverModel)
    }

    const damfiltModel = this.getDamfiltModel()
    if (damfiltModel !== undefined) {
      damfiltModel.opacity = 0.6
      modelsMerged.push(damfiltModel)
    }

    const damminModel = this.getDammin()
    if (damminModel !== undefined) {
      damminModel.opacity = 0.8
      modelsMerged.push(damminModel)
    }

    return modelsMerged
  }

  getDamaverModel() {
    try {
      const modelId = this.props.subtraction.abInitioModels[0].averagedModel.modelId
      const abInitioModelId = this.props.subtraction.abInitioModels[0].abInitioModelId
      let title = this.props.subtraction.abInitioModels[0].averagedModel.pdbFile
      title = title.split('/')[title.split('/').length - 1]
      return {
        type: 'AVERAGED',
        modelId: modelId,
        abInitioModelId: abInitioModelId,
        color: '0xFF6600',
        title: title,
        opacity: 0.5,
        radius: 3,
      }
    } catch (e) {
      // eslint-disable-next-line no-alert
      alert('Erreur : ', e)
    }
  }

  getDamfiltModel() {
    try {
      const modelId = this.props.subtraction.abInitioModels[0].rapidShapeDeterminationModel.modelId
      const abInitioModelId = this.props.subtraction.abInitioModels[0].abInitioModelId
      let title = this.props.subtraction.abInitioModels[0].rapidShapeDeterminationModel.pdbFile
      title = title.split('/')[title.split('/').length - 1]
      return {
        type: 'RAPIDSHAPEDETERMINATIONMODEL',
        modelId: modelId,
        abInitioModelId: abInitioModelId,
        color: '0x00CC00',
        title: title,
        opacity: 0.5,
        radius: 3,
      }
    } catch (e) {
      // eslint-disable-next-line no-alert
      alert('Erreur : ', e)
    }
  }

  getDammin() {
    try {
      const modelId = this.props.subtraction.abInitioModels[0].shapeDeterminationModel.modelId
      const abInitioModelId = this.props.subtraction.abInitioModels[0].abInitioModelId
      let title = this.props.subtraction.abInitioModels[0].shapeDeterminationModel.pdbFile
      title = title.split('/')[title.split('/').length - 1]
      return {
        type: 'SHAPEDETERMINATIONMODEL',
        modelId: modelId,
        abInitioModelId: abInitioModelId,
        color: '0x0099FF',
        title: title,
        opacity: 0.5,
        radius: 3,
      }
    } catch (e) {
      // eslint-disable-next-line no-alert
      alert('Erreur : ', e)
    }
  }
}
